import React, { useEffect, useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Menu,
  MenuItem,
  Fab,
  Grid,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import api from '../../api/api';

const CarListingPage = () => {

  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [currentCar, setCurrentCar] = useState(null);
  const [name, setName] = useState('');
  const [registrationNo, setRegistrationNo] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [dialogType, setDialogType] = useState('add');

  useEffect(() => {
    fetchCars();
  }, []);

  const fetchCars = async () => {
    try {
      const response = await api.get('/api/Cars');
      setCars(response.data);
    } catch (error) {
      console.error('Error fetching cars', error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenDialog = (type, car = null) => {

    setDialogType(type);
    setCurrentCar(car);
    if (car) {
      setName(car.name);
      setRegistrationNo(car.registrationNo);
    } else {
      setName('');
      setRegistrationNo('');
    }
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setCurrentCar(null);
    setName('');
    setRegistrationNo('');
  };

  const handleSaveCar = async () => {
    if (name.trim() === '' || registrationNo.trim() === '') {
      return;
    }

    try {
      if (dialogType === 'add') {
        await api.post('/api/Cars', { name, registrationNo });
      } else {
        const id = currentCar.id;
        await api.put(`/api/Cars/${currentCar.id}`, { id, name, registrationNo });
      }
      fetchCars();
      handleCloseDialog();
    } catch (error) {
      console.error('Error saving car', error);
    }
  };

  const handleDeleteCar = async () => {
    try {
      await api.delete(`/api/Cars/${currentCar.id}`);
      fetchCars();
      handleCloseDialog();
    } catch (error) {
      console.error('Error deleting car', error);
    }
  };

  const handleMenuOpen = (event, car) => {
    setCurrentCar(car);
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box  sx={{ p: 2 }}>
      <Typography marginBottom={2} component="p" variant="h5">Cars</Typography>
      {loading ? (
        <Typography>Loading...</Typography>
      ) : cars.length === 0 ? (
        <Typography>No Car Added.</Typography>
      ) : (
        <Grid container spacing={2}>
          {cars.map((car) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={car.id}>
              <Card>
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box>
                      <Typography variant="h6">{car.name}</Typography>
                      <Typography variant="body2">Registration No: {car.registrationNo}</Typography>
                    </Box>
                    <IconButton
                      aria-label="more"
                      aria-controls="long-menu"
                      aria-haspopup="true"
                      onClick={(event) => handleMenuOpen(event, car)}
                    >
                      <MoreVertIcon />
                    </IconButton>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={() => {
          handleOpenDialog('edit', currentCar);
          handleMenuClose();
        }}>Edit</MenuItem>
        <MenuItem onClick={() => {
          handleOpenDialog('delete');
          handleMenuClose();
        }}>Delete</MenuItem>
      </Menu>
      <Fab color="primary" aria-label="add" sx={{ position: 'fixed', bottom: 16, right: 16 }} onClick={() => handleOpenDialog('add')}>
        <AddIcon />
      </Fab>
      {(dialogType === 'add' || dialogType === 'edit') && (
        <Dialog open={openDialog} onClose={handleCloseDialog}>
          <DialogTitle>{dialogType === 'add' ? 'Add New Car' : 'Edit Car'}</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              label="Car Name"
              type="text"
              fullWidth
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <TextField
              margin="dense"
              label="Registration No"
              type="text"
              fullWidth
              value={registrationNo}
              onChange={(e) => setRegistrationNo(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog}>Cancel</Button>
            <Button onClick={handleSaveCar} variant="contained" color="primary">
              Save
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {dialogType === 'delete' && (
        <Dialog open={openDialog} onClose={handleCloseDialog}>
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <Typography>Are you sure you want to delete this car?</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog}>Cancel</Button>
            <Button onClick={handleDeleteCar} variant="contained" color="secondary">
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Box>
  );
};

export default CarListingPage;
